import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import LABELESPECIAL from '../../../business-const/Label/LabelEspecial'

import MESSAGE from '../../../business-const/Message/Message'

//import {
//    STYLEHTML
//} from '../../../business-const/Style/Style'

import {
    COLOR
} from '../../../business-const/Color/Color'

import {
    formataValor,
    formataEstudoPrevidenciaPrivadaResumo,
} from '../../../business-components/Formata/Formata'

//import {
//    ano,
//} from '../../../business-components/Date/Date'

import {
    GridContainer,
    GridContainerS0,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    ChartPadrao
} from '../../../business-components/Chart/Chart'

import {
//    ateMaisXAnos,
//    relatorioModoApresentacao,
} from '../estudo-form/EstudoService'

//import {
//    calculaJaAposentou,
//} from '../estudo-form/EstudoServiceCalculo'

//import {
//    CardGridEstudoPadrao,
//} from '../estudo-form/EstudoComp'



const PrevidenciaPrivadaChart = ( { values, estudo, graficoPrevidenciaPrivada, graficoPrevidenciaPrivadaAporte,
    graficoPrevidenciaPrivadaRentabilidade, valorRetiradaMensalMaximaConsumirReservaAposentadoria,
        graficoPrevidenciaPrivadaConsumirReservaAposentadoria, valorRetiradaMensalMaximaPreservarReservaAposentadoria,
            graficoPrevidenciaPrivadaPreservarReservaAposentadoria, indexTotalAcumulado, projetoVidaSonho, report,
                simulacao, despesaDetutivelMensalPrevidenciaPrivadaCalc, valorEconomiaInventarioPrevidenciaPrivada } ) => {

    const PrevidenciaPrivada = ( props ) => {

        //const jaAposentou = calculaJaAposentou(values, ano(values.dataSimulacaoEstudo))

        const series = []

        const paletaCoresEspecifica = []

        /*
        if (!values.utilizarVersaoSimplificadaGraficoDiagnosticoAposentadoriaIndependênciaFinanceira) {

            if (valorRetiradaMensalMaximaConsumirReservaAposentadoria !== 0) {
                series.push(
                    {
                        name: LABEL.retiradaMensalMaximaConsumirReserva.replace('$1$',
                            formataValor(valorRetiradaMensalMaximaConsumirReservaAposentadoria, 2)),
                        type: 'line',
                        data: graficoIndependenciaFinanceiraConsumirReservaAposentadoria,
                    },
                )

                paletaCoresEspecifica.push(
                    COLOR().corChartPadraoConsumirReservaSemNovosAportes,
                )
            }

            if (valorRetiradaMensalMaximaPreservarReservaAposentadoria !== 0) { 
                series.push(
                    {
                        name: LABEL.retiradaMensalMaximaPreservarReserva.replace('$1$',
                            formataValor(valorRetiradaMensalMaximaPreservarReservaAposentadoria, 2)),
                        type: 'line',
                        data: graficoIndependenciaFinanceiraPreservarReservaAposentadoria,
                    },
                )

                paletaCoresEspecifica.push(
                    COLOR().corChartPadraoManterReservaSemNovosAportes,
                )
            }
        }
        */

        series.push(
            {
                name: LABEL.previdenciaPrivada,
                type:
                    values.utilizarVersaoSimplificadaGraficoDiagnosticoAposentadoriaIndependênciaFinanceira
                        ?
                            'line'
                        :
                            'area',
                data: graficoPrevidenciaPrivada,
            },
        )

        paletaCoresEspecifica.push(
            COLOR().corChartPadraoPrevidenciaPrivada
        )

        series.push(
            {
                name: LABEL.aporte,
                type: 'area',
                data: graficoPrevidenciaPrivadaAporte,
            },
        )

        paletaCoresEspecifica.push(
            COLOR().corChartPadraoPrevidenciaPrivadaAporte
        )

        series.push(
            {
                name: LABEL.rentabilidade,
                type: 'area',
                data: graficoPrevidenciaPrivadaRentabilidade,
            },
        )

        paletaCoresEspecifica.push(
            COLOR().corChartPadraoPrevidenciaPrivadaRentabilidade
        )



        if (!projetoVidaSonho) {

            series.push(
                {
                    name: LABEL.consumirReserva.replace('$1$',
                        formataValor(valorRetiradaMensalMaximaConsumirReservaAposentadoria, 2)),
                    type: 'line',
                    data: graficoPrevidenciaPrivadaConsumirReservaAposentadoria,
                },
            )

            paletaCoresEspecifica.push(
                COLOR().corChartPadraoPrevidenciaPrivadaConsumirReserva
            )

            series.push(
                {
                    name: LABEL.preservarReserva.replace('$1$',
                        formataValor(valorRetiradaMensalMaximaPreservarReservaAposentadoria, 2)),
                    type: 'line',
                    data: graficoPrevidenciaPrivadaPreservarReservaAposentadoria,
                },
            )

            paletaCoresEspecifica.push(
                COLOR().corChartPadraoPrevidenciaPrivadaPreservarReserva
            )
        }
        


        const categories = projetoVidaSonho ? estudo.current.graficoAnos : estudo.current.graficoIdades

        //const GridTabelas = report ? GridItem12 : GridItem11

        const GridGrafico = report ? GridItem12 : GridItem11

        const reportDiagnostico = values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioPaisagem ? false : report

        return (
            <div
                {...props}
            >
                <GridContainer>
                    <GridItem12>
                        <GridContainerS0>
                            <GridGrafico
                                //className={report ? 'mt--5' : 'mt--15' /* mudança da fonte: 'mt--0' */}
                            >
                                <div
                                    className='ml-5'
                                >
                                    <ChartPadrao
                                        titleText={''} // mudança da fonte: titleText={popup ? '' : LABEL.diagnosticoAposentadoriaIndependenciaFinanceira}
                                        type={values.utilizarVersaoSimplificadaGraficoDiagnosticoAposentadoriaIndependênciaFinanceira ? 'line' : 'area'}
                                        series={series}
                                        //height={report ? 300 : 500}
                                        //legendHorizontalAlign={'left'}
                                        stacked={false}
                                        categories={categories}
                                        categories2={projetoVidaSonho ? estudo.current.graficoIdades : estudo.current.graficoAnos}
                                        paletaCores={paletaCoresEspecifica}
                                        //notLegendShow={true}
                                        dataLabelsEnabled={false}
                                        dataLabelsEnabledReport={values.formatoReport === HARDCODE.idFormatoReportImpressao}
                                        dataLabelsType='Idade'
                                        dataLabelsInterval={-1}
                                        dataLabelsDestaque={[categories[indexTotalAcumulado]]}
                                        notInverseOrder={true}
                                        //legendFixedEnabled={true}
                                        toolTipX={true}
                                        toolTipXTotal={false}
                                        xaxisRotate={projetoVidaSonho ? -70 : ''}
                                        report={reportDiagnostico/*true*//*report*/}
                                        formatoReport={values.formatoReport}
                                        fillOpacity={0.7}//0.8
                                    />
                                </div>

                                <GridContainerS0>
                                     <GridItem12
                                        className={report ? 'mt--7' : 'mt-2'}
                                        align='center'
                                    >
                                        {formataEstudoPrevidenciaPrivadaResumo(
                                            MESSAGE(values, reportDiagnostico).previdenciaPrivadaResumo
                                                .replace('$1$', categories[indexTotalAcumulado])
                                                .replace('$2$', (projetoVidaSonho ? '' : ' ' + LABELESPECIAL.anos))
                                                .replace('$3$',
                                                    formataValor(graficoPrevidenciaPrivada[indexTotalAcumulado], 2))
                                                .replace('$4$',
                                                    formataValor(graficoPrevidenciaPrivadaAporte[indexTotalAcumulado], 2))
                                                .replace('$5$', formataValor(
                                                    graficoPrevidenciaPrivadaRentabilidade[indexTotalAcumulado], 2)),
                                            report && !simulacao
                                        )}
                                    </GridItem12>

                                    <GridItem12
                                        className='mt-3'
                                        align='center'
                                    >
                                        {valorEconomiaInventarioPrevidenciaPrivada && (
                                            formataEstudoPrevidenciaPrivadaResumo(
                                                MESSAGE(values, reportDiagnostico).previdenciaPrivadaResumoEconomiaInventario
                                                    .replace('$1$',
                                                        formataValor(graficoPrevidenciaPrivada[indexTotalAcumulado], 2))
                                                    .replace('$2$',
                                                        formataValor(valorEconomiaInventarioPrevidenciaPrivada, 2)),
                                                report && !simulacao
                                            )
                                        )}
                                    </GridItem12>
                                </GridContainerS0>

                                
                            </GridGrafico>
                        </GridContainerS0>

                        {!simulacao && (
                            <GridContainerS0>
                                <GridItem11
                                    className={report ? 'mt--94' : 'mt--107'}
                                    align='center'
                                >
                                    {formataEstudoPrevidenciaPrivadaResumo(
                                        MESSAGE(values, reportDiagnostico).previdenciaPrivadaAporteMensalPGBL
                                            .replace('$1$',
                                                formataValor(despesaDetutivelMensalPrevidenciaPrivadaCalc, 2)),
                                        report && !simulacao
                                    )}
                                </GridItem11>
                            </GridContainerS0>
                        )}

                    </GridItem12>
                </GridContainer>
            </div>       
        )
    }

    return (
        <GridItem12>
            <PrevidenciaPrivada
                className={(report ? 'mt-1' : 'mt-5') + ' ml-3'}
            />
        </GridItem12>
    )
}

export default PrevidenciaPrivadaChart